// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sspFY","controls":"styles_controls__2g0OF","charLimit":"styles_charLimit__NTp5S","input":"styles_input__l1jht","send":"styles_send__39DoX"};